// Made by studio/make-brand.js from studio/drafts/brand/knock-token.png: do not edit by hand.
export const MARK = [
  '........................................',
  '........................................',
  '........................................',
  '........................................',
  '...............##########...............',
  '.............##..........##.............',
  '............#...#####.###..#............',
  '..........##..####.#####.#..##..........',
  '..........#.###.###########..#..........',
  '.........#.#.#####.#####.####.#.........',
  '........#..####.##....#######..#........',
  '........#.##.####......#.#####.#........',
  '.......#..#####.........###.###.#.......',
  '.......#.###.##..........#####..#.......',
  '.......#..#####..........##.###.#.......',
  '.......#.###.##..........#####..#.......',
  '.......#.######..........##.###.#.......',
  '.......#.###.##..........#####..#.......',
  '.......#..#####.rrr..rrr.##.###.#.......',
  '.......#.###.##.rrr..rrr.#####..#.......',
  '.......#..#####..........##.###.#.......',
  '.......#.###.###.........#####..#.......',
  '.......#..#####.#......####.###.#.......',
  '.......#..##.###.......#.#####..#.......',
  '.......#..#####.#......####.###.#.......',
  '.......#.###.####......#.#####..#.......',
  '.......#..####............#.###.#.......',
  '.......#.###...............#.#..#.......',
  '.......#..##................###.#.......',
  '.......#.#...................#..#.......',
  '.......#..#..................##.#.......',
  '.......#........................#.......',
  '.......#......................#.#.......',
  '.......#.#......................#.......',
  '.......#......................#.#.......',
  '.......#........................#.......',
  '.......#........................#.......',
  '.......#........................#.......',
  '.......#........................#.......',
  '.......#........................#.......',
];
